module.exports = __webpack_public_path__ + "media/application/images/img/overlays/02-351bd6828f980ec53eb3a1ad0d3b1e31.png";